import { type StoryblokProductSearchRangeType } from '../StoryblokProductSearchFilters.types'

export const storyblokProductSearchFiltersParseRangeFilterToQueryString = (
  fieldName: string,
  range: StoryblokProductSearchRangeType,
): string | null => {
  const { max, min } = range
  const rangeFilters = []

  if (Number.isFinite(min)) {
    rangeFilters.push(`${fieldName} >= ${min}`)
  }

  if (Number.isFinite(max)) {
    rangeFilters.push(`${fieldName} <= ${max}`)
  }

  return rangeFilters.length > 0 ? `(${rangeFilters.join(' AND ')})` : null
}
